import { render, staticRenderFns } from "./ListCompetenciesAndUserDefinitions.vue?vue&type=template&id=274071fd&scoped=true"
import script from "./ListCompetenciesAndUserDefinitions.vue?vue&type=script&lang=js"
export * from "./ListCompetenciesAndUserDefinitions.vue?vue&type=script&lang=js"
import style0 from "./ListCompetenciesAndUserDefinitions.vue?vue&type=style&index=0&id=274071fd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "274071fd",
  null
  
)

export default component.exports